<script setup lang="ts">
import CommonButton from '@/components/common/button/CommonButton.vue'
import UserManagementTable from '@/components/userManagement/UserManagementTable.vue'
import UserDeleteConfirmDialog from './UserDeleteConfirmDialog.vue'
import { useUserPartsCombination } from '@/composables/userManagement/useUserPartsCombination'
import UserRegistrationModal from './UserRegistrationModal.vue'
import UserRegistrationSuccessDialog from './UserRegistrationSuccessDialog.vue'

const { checkedItems, createUser, deleteUser } = useUserPartsCombination()
</script>

<template>
  <div>
    <div class="d-flex justify-content-end align-items-center">
      <div>
        <CommonButton variant="primary" size="lg" class="fs-5" @click="createUser"
          >新規作成</CommonButton
        >
      </div>
      <div>
        <CommonButton
          variant="outline-primary"
          size="lg"
          class="fs-5 mx-4 delete-button"
          @click="deleteUser"
          :disabled="checkedItems.length === 0"
          >削除</CommonButton
        >
      </div>
    </div>
    <UserManagementTable v-model:checked-items="checkedItems" class="mt-4"></UserManagementTable>
  </div>
  <UserRegistrationModal ref="userRegistrationModal"></UserRegistrationModal>
  <UserRegistrationSuccessDialog
    ref="userRegistrationSuccessDialog"
  ></UserRegistrationSuccessDialog>
  <UserDeleteConfirmDialog
    :checkedItems="checkedItems"
    ref="userDeleteConfirmDialog"
  ></UserDeleteConfirmDialog>
</template>

<style lang="scss" scoped>
.delete-button {
  background-color: #ffffff !important;
}
</style>
